import { Injectable } from '@angular/core';
import gql from 'graphql-tag';
import { GraphQLClient } from '../shared/services/graph-qlclient.service';

@Injectable({
  providedIn: 'root'
})
export class ProvinciaService {

  constructor(
    private gqlclient: GraphQLClient
  ) { }

  obtenerSegunFiltro(inputParams: {
    entidad: {
      codigo: number
      nombre: string
      region_codigo: number
    }
  }, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
        query ($entidad: provinciaInputType) {
          provincia {
            obtenerSegunFiltro(filtro: {exacto: $entidad}) {
              mensajes {
                codigo
                texto
                tipo
              }
              respuesta {
                registros {
                  codigo
                  nombre
                  region_codigo
                }
              }
            }
          }
        }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.provincia.obtenerSegunFiltro
        callback({ mensajes, respuesta })
      }
    );
  }

}
